import List from 'offices/List'
import Create from 'offices/Create'
import Update from 'offices/Update'

export default {
  List,
  Create,
  Update,
}
